import { motion } from "framer-motion";
import { Mail } from "lucide-react";

export default function CtaBand() {
  return (
    <section id="connect" data-testid="connect" className="grain bg-navy">
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-6 px-5 py-16 sm:px-8 sm:py-20 md:flex-row md:items-center md:justify-between">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="max-w-xl"
        >
          <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-pink">
            All done?
          </div>
          <h2 className="mt-3 text-[26px] font-bold leading-[1.15] tracking-[-0.02em] text-white md:text-[32px]">
            Tell Pep and we'll take it from here.
          </h2>
          <p className="mt-3 text-base text-white/70">
            One quick email once you've granted access, and your strategist starts the audit.
          </p>
        </motion.div>

        <motion.a
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          data-testid="email-pep-button"
          href="mailto:pep@smartmarketer.com?subject=Access%20granted"
          className="inline-flex shrink-0 items-center gap-2.5 rounded-full bg-pink px-8 py-4 text-base font-bold text-white shadow-[0_8px_24px_-6px_rgba(242,0,94,0.45)] transition-all duration-200 hover:bg-pink-dark active:scale-[0.98]"
        >
          <Mail className="h-4 w-4" />
          Email pep@smartmarketer.com
        </motion.a>
      </div>
    </section>
  );
}
